import React, { useState } from "react";

const ResearchDataset = () => {

  const [form, setForm] = useState({
    datasetName: "",
    modality: "",
    bodyPart: "",
    icd10: "",
    dateFrom: "",
    dateTo: "",
    limit: 100
  });

  const [loading, setLoading] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");

  const createDataset = async () => {

    setLoading(true);
    setDownloadUrl("");

    try {

      const response = await fetch(
        "https://umth.haske.online/api/research/create-batch-dataset",
        {
          method: "POST",
          headers: {
            "Content-Type":"application/json"
          },
          body: JSON.stringify(form)
        }
      );

      const data = await response.json();

      if(data.success){
        setDownloadUrl(data.downloadUrl);
      }
      else{
        alert(data.message);
      }

    } catch(err){
      console.error(err);
      alert("Dataset creation failed");
    }

    setLoading(false);
  };


  return (
    <div style={{padding:"30px"}}>

      <h2>Research Dataset Builder</h2>

      <input
        placeholder="Dataset Name"
        onChange={e =>
          setForm({...form,datasetName:e.target.value})
        }
      />

      <br/><br/>

      <select
        onChange={e =>
          setForm({...form,modality:e.target.value})
        }
      >

        <option value="">Any Modality</option>
        <option value="CR">Xray (CR)</option>
        <option value="CT">CT</option>
        <option value="MR">MRI</option>
        <option value="US">Ultrasound</option>

      </select>


      <br/><br/>

      <input
        placeholder="ICD10 e.g J18"
        onChange={e =>
          setForm({...form,icd10:e.target.value})
        }
      />


      <br/><br/>


      <input
        placeholder="Start date 20240101"
        onChange={e =>
          setForm({...form,dateFrom:e.target.value})
        }
      />


      <br/><br/>


      <input
        placeholder="End date 20261231"
        onChange={e =>
          setForm({...form,dateTo:e.target.value})
        }
      />


      <br/><br/>


      <button onClick={createDataset}>
        {loading ? "Creating..." : "Create Dataset"}
      </button>


      <br/><br/>


      {downloadUrl && (

        <a
          href={`https://umth.haske.online${downloadUrl}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Dataset
        </a>

      )}

    </div>
  );
};


export default ResearchDataset;